module.exports = __webpack_public_path__ + "static/media/YoutubeLogo.a3bc837f.png";